import { MicrosoftAuthConfig } from '@msal';

export const environment = {
  name: 'preprod',
  production: true,
  remoteApi: 'https://merchadminpreprod-api.rmxrewardstore.com/api',

  microsoft: {
    clientId: 'f5c181ab-57eb-4655-8323-5c28d468c05e',
    authority: 'https://login.microsoftonline.com/6a7ef1e2-9e9e-412e-9824-b8c2856ce8f4',
    redirectUri: 'https://merchadminpreprod.rmxrewardstore.com/',
    protectedResources: [
      {
        url: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['user.read'],
      },
      {
        url: 'https://merchadminpreprod.rmxrewardstore.com/',
        scopes: ['api://f5c181ab-57eb-4655-8323-5c28d468c05e/Default'],
      },
      {
        url: 'https://merchadminpreprod-api.rmxrewardstore.com/',
        scopes: ['api://f5c181ab-57eb-4655-8323-5c28d468c05e/Default'],
      },
    ],
    protectedResourcesDefaultScope: ['api://f5c181ab-57eb-4655-8323-5c28d468c05e/Default'],
  } satisfies MicrosoftAuthConfig,
};
